import noaWeb from '../Assets/Projects/noatalelWeb.png';
import simulator from '../Assets/Projects/simulator.png';
import foodApp from '../Assets/Projects/foodApp.png';
import pongGame from '../Assets/Projects/pongGame.png';
import FashionWeb from '../Assets/Projects/FashionWeb.png';
import TravelApp from '../Assets/Projects/travelApp.jpg';
import Bookstore from '../Assets/Projects/bookstore.png';
import ChargeMonitor from '../Assets/Projects/ChargeMonitor.webp';
import helenaWeb from '../Assets/Projects/helenaWeb.png';

export const CLIENT_PROJECTS = [

  {
    id: 'helenas-consulting',
    title: "Helena - Couples & Family Consulting",
    description: 'Developed the business website using Cursor with Claude and a Skills based development workflow. Built a fully responsive website with a strong focus on clean UI, user experience, and performance across both mobile and desktop. The project was executed using an AI-assisted development approach, leveraging AI tools to accelerate implementation and improve overall development efficiency.',
    image: helenaWeb,
    githubLink: 'https://helenam.co.il/',
    isBlog: false,
  },
  {
    id: 'charge-monitor',
    title: 'ChargeMonitor',
    description: 'The application checks the availability of electric vehicle charging stations via an API, fetching data every 5 minutes. If the availability changes, it sends an email notification. The data is stored in Prometheus for real-time monitoring, and a Flask server serves the metrics at the /metrics endpoint. The system runs with two threads: one for Flask and one for monitoring the stations and sending alerts.',
    image: ChargeMonitor,
    githubLink: 'https://github.com/amitha511/empty-spot-notifier',
    isBlog: true,
    imageConfig: { h: 250, m: '12%', w: 300 },
  },
  {
    id: 'cosmetic-website',
    title: 'Noa Tal El cosmetics - website',
    description: 'A dynamic website for a cosmetics business using React and Node.js. The site contains a very impressive product catalog, the implementation of an efficient shopping cart system, the presentation of the expertise, services and portfolio of the business, and many other features.',
    image: noaWeb,
    githubLink: 'https://noatal-el.com/',
    isBlog: false,
  },
];

export const PERSONAL_PROJECTS = [
  {
    id: 'travel-app',
    title: 'Travel App',
    description: 'Developed a travel schedule app designed to create personalized itineraries for users. The application utilizes the Google API to gather attraction data, ensuring an enriching travel experience. The project encompassed several key features: user authentication, custom trip algorithm, attraction Sorting, travel Page and more. Technologies used: React Native, Expo, Bootstrap, NodeJS and MongoDB.',
    image: TravelApp,
    githubLink: 'https://github.com/amitha511/react-native-travel-app',
    isBlog: true,
    imageConfig: { h: 250, m: '30%', w: 150 },
  },
  {
    id: 'foodies-app',
    title: 'Foodies App',
    description: 'Android application development with MVC architecture. Using Google\'s design guidelines. User authentication using the Firebase authentication server. Remote storage on the Firebase database server of objects and images. Implement image and object caching using Room-SQLite (local database). Using fragments, navigation graph and passing parameters using safeArgs.',
    image: foodApp,
    githubLink: 'https://github.com/amitha511/foodies_app',
    isBlog: true,
    imageConfig: { h: 250, m: '4%', w: 250 },
  },
  {
    id: 'fashion-shop',
    title: 'Fashion Shop',
    description: 'Website development with MVC architecture, contains development of CRUD operations for product management with administrator authentication. Post advertising application on Facebook via Facebook API, impressive user interface catalog with filtering options and more property. Technologies used: JavaScript, NodeJS and MongoDB for backend development.',
    image: FashionWeb,
    githubLink: 'https://github.com/amitha511/fashion_store_website',
    isBlog: true,
  },
  {
    id: 'bookstore',
    title: 'Bookstore Website',
    description: 'End-to-end development of an interactive website for a bookstore. The project introduced an array of advanced functionalities aimed at optimizing user engagement and operational efficiency. User interface catalog with diverse filter options, manager authentication system, dynamic CRUD operations, in-depth shopping analysis on the manager page. Technologies used: React, Bootstrap, Firebase, Socket.IO, NodeJS and MongoDB.',
    image: Bookstore,
    githubLink: 'https://github.com/amitha511/bookstore-website',
    isBlog: true,
  },
  {
    id: 'flight-simulator',
    title: 'Flight Simulator',
    description: 'The javaFX-flightSimulator it\'s a joystick that connects remotely to a flight simulator FlightGear, The joystick controls the flight of the aircraft.',
    image: simulator,
    githubLink: 'https://github.com/amitha511/flight-simulator',
    isBlog: true,
  },
  {
    id: 'pong-game',
    title: 'Pong Game',
    description: 'A simple pong game for multiplayer.',
    image: pongGame,
    githubLink: 'https://github.com/amitha511/pong-game',
    isBlog: true,
  },
];